<template>
  <div class="input-panel panel-facility">
    <template v-if="!facilityCategory.id">
      <h2 class="input-panel__head panel-facility__head">Facility Profiles</h2>
        
      <ul class="facility-grid">
        <li class="facility-grid__item"
          v-for="facilityCategory in facilityProfiles"
        >
          <a href="#" @click.prevent="selectFacilityCategory(facilityCategory)" class="facility-grid__link">
            <div class="facility-grid__img">
              <img :src="imgPath(facilityCategory.thumb)" :alt="facilityCategory.name">
            </div>
            <div class="facility-grid__title"
              v-html="facilityCategory.name"></div>
          </a>
        </li>
        <li class="facility-grid__item" 
          v-if="allowCustomFacilityProfile"
        >
          <a href="#" class="facility-grid__link" @click.prevent="customProfile">
            <div class="facility-grid__frame">
              <div class="facility-grid__img facility-grid__img--flip">
                <img src="/assets/img/facility/custom-profile.jpg" alt="Custom Profile">
                <div class="facility-grid__img-back"><div>Increased</div> <div>Accuracy</div></div>
              </div> 
            </div>
            <div class="facility-grid__title">Custom<br>Profile</div>
          </a>
        </li>
        <li class="facility-grid__item" 
          v-if="!allowCustomFacilityProfile"
        >
          <div class="facility-grid__link facility-grid__link--disabled"
            @click="displaySecondaryCustomProfileMessage = true"
          >
            <div class="facility-grid__img"
              :class="{ 'facility-grid__img--flipped' : displaySecondaryCustomProfileMessage, 'facility-grid__img--flip' : !displaySecondaryCustomProfileMessage, 'facility-grid__img--flip-once' : !displaySecondaryCustomProfileMessage }"
            >
              <img src="/assets/img/facility/custom-profile.jpg" alt="Custom Profile">
              <div class="facility-grid__img-back">
                
                <template>
                  <div>Increased</div> <div>Accuracy</div>
                </template>
              </div>

              <a :href="upgradeLink" @click.prevent="loadAccountView" class="facility-grid__plan-msg" :class="{ 'facility-grid__plan-msg--active' : displaySecondaryCustomProfileMessage }">
                <div>Subscription</div> <div>Required</div>
              </a>

            </div> 
            <div class="facility-grid__title">Custom<br>Profile</div>
          </div>
        </li>
      </ul>
    </template>

    <facility-options 
      v-else 
      :option-set="optionSet" 
    ></facility-options>
    
  </div>
</template>

<script>
import router from '../../../router'
import swal from 'sweetalert'
import FacilityOptions from './FacilityOptions.vue'

export default {
  components: {
    'facility-options': FacilityOptions
  },
  data () {
    return {
      baseImgPath: '',
      displaySecondaryCustomProfileMessage: false,
      workspaceHasValues: true,
    }
  },
  computed: {
    utilityPlan() {
      return this.$store.getters.utilityPlan
    },
    isFreeOrReg() {
      if (this.currentPricingRequest.utility.plan.slug === 'free' || this.currentPricingRequest.utility.plan.slug === 'free-registered') {
        return true
      } 

      return false
    },
    upgradeLink() {
      switch(this.currentPricingRequest.utility.plan.slug) {
        case 'free-registered':
          return '/account/subscription'
        case 'free':
          return '/subscribe'
        break
      }
    },
    currentPricingRequest() {
      return this.$store.getters.currentPricingRequest
    },
    planConfig() {
      return this.$store.getters.planConfig
    },
    facilityProfiles() {
      return this.$store.getters.facilityProfiles
    },
    facilityCategory() {
      return this.$store.getters.facilityCategory
    },
    optionSet() {
      return this.facilityCategory.options
    },
    utilityId() {
      if (this.currentPricingRequest.utilityMeta) {
        return this.currentPricingRequest.utilityMeta.id
      }
    },
    customFacilityProfileView() {
      return this.$store.getters.customFacilityProfileView
    },
    allowCustomFacilityProfile() {
      return ['basic', 'premium', 'premium-legacy-1'].includes(this.currentPricingRequest.utility.plan.slug)
    },
    facilityTree() {
      if (this.currentPricingRequest.facilityType.parents) {
        let parents = this.currentPricingRequest.facilityType.parents.slice()
        parents = parents.reverse()
        return parents
      }

      return false     
    }
  },
  methods: {
    imgPath(img) {
      return this.baseImgPath + img
    },
    selectFacilityCategory(facilityCategory) {
      this.$store.dispatch('setFacilityCategory', {
        id: facilityCategory.id,
        name: facilityCategory.name,
        thumb: facilityCategory.thumb,
        parents: facilityCategory.parents,
        options: facilityCategory.options,
        columns: 1,
      })
    },
    customProfile() {
      router.push({ name: 'CustomFacilityProfile' })
    },
    loadAccountView() {
      if (this.workspaceHasValues && this.utilityPlan.slug !== 'free') {
        let upgradeLink = this.upgradeLink

        let swalContent = document.createElement('div')
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will clear any unsaved changes in your workspace view, are you sure you want to leave?</p>'

        swal({
          content: swalContent,
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: 'Cancel',
              value: null,
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: 'Yes',
              value: true,
              visible: true,
              closeModal: true
            }
          }
        }).then(result => {
          if (result) {
            setTimeout(() => {
              window.location.href = upgradeLink
            }, 500)
          }
        }).catch(() => {})
      } else {
        window.location.href = this.upgradeLink
      }
    }
  },
  created() {
    if (this.utilityId) {
      this.$store.dispatch('fetchFacilityProfiles', this.utilityId)
    }

    // Set Facility Category view if a config has been saved/loaded
    if (this.currentPricingRequest.facilityType.id) {
      let facilityCategory = null

      if (Object.keys(this.facilityProfiles).length && this.facilityTree) {
        facilityCategory = this.facilityProfiles.filter(profile => profile.id === this.facilityTree[0])
      } else {
        facilityCategory = this.facilityProfiles.filter(profile => profile.id === this.currentPricingRequest.facilityType.id)
      }

      this.$store.dispatch('setFacilityCategory', {
        id: facilityCategory[0].id,
        name: facilityCategory[0].name,
        thumb: facilityCategory[0].thumb,
        options: facilityCategory[0].options,
        parents: facilityCategory[0].parents,
        twoColumns: facilityCategory[0].twoColumns,
        checkboxOptions: facilityCategory[0].checkboxOptions,
        preventVolumeReset: true,
      })    
    }

    // Custom profile flip animation:
    if (!this.allowCustomFacilityProfile) {
      setTimeout(() => {
        this.displaySecondaryCustomProfileMessage = true
      }, 7000)
    }
  },
  mounted() {    
    if (this.customFacilityProfileView) {
      this.customProfile()
    }
  }
}
</script>
